import RedirectToHome from './redirect-to-home';

export default RedirectToHome;
export { REDIRECT_COUNTDOWN_SECONDS } from './redirect-to-home';
